import { EVChargerOutput, EVChargerStatus, EVChargerOutputStatus, EVChargerOutputPort, EVChargerOutputPortStatus } from '../../entity/station/evcharger';

export class EVChargerOutputPortTransformer {
    transform(portInfo: any) : EVChargerOutputPort {
        let port = new EVChargerOutputPort(
            portInfo.portId,
            portInfo.portType            
        )
        if(portInfo.status) {
            port.status = new EVChargerOutputPortStatus(portInfo.status.code, portInfo.status.description)
        }    
        return port    
    }

    deTransform(port: EVChargerOutputPort) : any {
        let portInfo: any = {
            portId: port.id,
            portType: port.type,            
        }
        if(port.status) {
            portInfo = {
                ...portInfo,                
                status: {
                    code: port.status.id
                }
            }
        }
        return portInfo
    }
}